import React from 'react'

interface IProps {
  children: JSX.Element
  key: string
  name: string
  icon?: string
}

class Tab extends React.Component<IProps> {
  public render(): JSX.Element {
    return <div className="Tab col">{this.props.children}</div>
  }
}

export default Tab
